import SolutionLayout, {
  type SolutionData,
} from "../../components/SolutionLayout";
import {
  CodeIcon,
  PlugIcon,
  TagIcon,
} from "../../components/Icons";

const data: SolutionData = {
  path: "/solutions/subscription",
  eyebrow: "Solution · Subscription & recurring",
  headline: "See the subscriber's plan before you answer.",
  lede: "Subscription questions are about plans, renewals and payments, which live in your own billing system. ZopDesk shows those details on the ticket through the customer data lookup, and ticket actions hand the ticket to your systems when something needs doing there.",
  stats: [
    { value: "Lookup", label: "Plan and renewal on the ticket", sub: "From your own system" },
    { value: "Actions", label: "Buttons on tickets", sub: "Up to 10, each with its own endpoint" },
    { value: "Rules", label: "Tag cancellation requests", sub: "Match \"cancel\" in subject or message" },
  ],
  painFix: [
    {
      pain: "Agents switch to the billing system to check a subscriber's plan, renewal date and last payment before replying.",
      fix: "Run an HTTPS endpoint that returns those details for a customer, and ZopDesk shows them in the ticket sidebar. You decide which fields and links appear.",
    },
    {
      pain: "Requests like \"pause my plan\" mean copying details into another tool by hand.",
      fix: "Add a ticket action such as \"Pause subscription\". The agent clicks it, ZopDesk posts the ticket to your endpoint, your answer is saved as an internal note, and the ticket can be solved automatically.",
    },
    {
      pain: "Cancellation requests get the same treatment as every other ticket.",
      fix: "A rule can tag and assign tickets whose subject or message mentions \"cancel\", so the people who handle retention see them first.",
    },
  ],
  highlights: [
    {
      Icon: CodeIcon,
      title: "Customer data lookup",
      body: "Plan, renewal date, payment status: whatever your endpoint returns, shown on every ticket. Requests are signed with HMAC.",
    },
    {
      Icon: PlugIcon,
      title: "Ticket actions",
      body: "Buttons that send the ticket, customer and conversation to your system, with the answer recorded on the ticket.",
    },
    {
      Icon: TagIcon,
      title: "Rules",
      body: "Match words in the subject or message and tag, assign or set priority as tickets arrive.",
    },
  ],
  relatedSolutions: [
    { to: "/solutions/dtc", label: "Direct-to-consumer" },
    { to: "/solutions/b2b", label: "B2B & wholesale" },
    { to: "/solutions/marketplaces", label: "Marketplaces" },
  ],
};

export default function SolutionSubscription() {
  return <SolutionLayout data={data} />;
}
